import { z } from "zod";
import { ResponseGetCdtTreeSchema } from "@CommonApi/cdt/trees/_treeId_/index";

export const RoutePostCdtTrees_treeId_Clone = "/cdt/trees/:treeId/clone";

export const PostCloneCdtTreeBodySchema = z.object({
  name: z.string().min(1).max(255),
});

export const ResponsePostCloneCdtTreeSchema = ResponseGetCdtTreeSchema;

export type PostCloneCdtTreeBody = z.infer<typeof PostCloneCdtTreeBodySchema>;
export type ResponsePostCloneCdtTree = z.infer<typeof ResponsePostCloneCdtTreeSchema>;
